import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import ConfigMenu from './config/ConfigMenu';
import 'react-circular-progressbar/dist/styles.css';
import { default as Stepper } from './components/stepper';


let py = require('./config/payment.json');
let logo = require('./../src/img/Logo.png');



export let Etapes = [
    {
        number: 1,
        Desc: "Choisissez votre point de retrait",
        Deschtml: <div className="rowstep">Point de retrait</div>

    },
    {
        number: 2,
        Desc: "Choisissez votre Sweethé et sa taille",
        Deschtml: <div className="rowstep">Taille</div>
    },
    {
        number: 3,
        Desc: "Thé",
        Deschtml: <div className="rowstep">Choix du thé</div>
    },
    {
        number: 4,
        Desc: "Parfums",
        Deschtml: <div className="rowstep">Parfums</div>
    },
    {
        number: 5,
        Desc: "Sucre",
        Deschtml: <div className="rowstep">Sucre</div>
    },
    {
        number: 6,
        Desc: "Garnitures",
        Deschtml: <div className="rowstep">Garnitures</div>
    },
    {
        number: 7,
        Desc: "Commande",
        Deschtml: <div className="rowstep">Validez</div>
    }
]

export let LevelToEtape = [
    Etapes[0],
    Etapes[1],
    Etapes[1],
    Etapes[2],
    Etapes[3],
    Etapes[4],
    Etapes[5],
    Etapes[6],
    Etapes[6],
]



export let RenderSelected = (etp, state) => {
    const getCurrentCardItem = () => state.card.find(cx => cx.id === state.currentCardItem)
    const getBoisson = () => ConfigMenu.getBoisson(getCurrentCardItem().boisson)
    const getTaille = () => ConfigMenu.getTaille(getCurrentCardItem().boisson, getCurrentCardItem().taille)
    const getThe = () => ConfigMenu.getThe(getCurrentCardItem().boisson, getCurrentCardItem().taille, getCurrentCardItem().the)
    const getParfum = (ref) => ConfigMenu.getParfum(getCurrentCardItem().boisson, getCurrentCardItem().taille, ref)
    const getParfums = () => getCurrentCardItem().parfums.map(x => getParfum(x))
    const getSucre = () => ConfigMenu.getSucrebyRef(getCurrentCardItem().sucre)
    switch (etp) {
        case 1:
            if (state.level > 0)
                if (state.pointderetrait)
                    return (<>
                        <div className="current">
                            <div className="rpointderetrait">
                                {state.pointderetrait.name}
                            </div>
                        </div>

                    </>)
            break;
        case 2:
            if (state.level > 2)
                if (getCurrentCardItem().boisson && getCurrentCardItem().taille)
                    return (<>
                        <div className="current">
                            <div className="rformule">
                                <span>{getTaille().name}</span>
                                <img src={getBoisson().imgsp} alt="" />
                            </div>
                        </div>
                    </>)
            break;
        case 3:
            if (state.level > 3)
                if (getCurrentCardItem().the)
                    return (<>
                        <div className="current">
                            <div className="the">
                                <span>{getThe().name}</span>
                                <img src={getThe().img} alt="" />
                            </div>
                        </div>
                    </>)
            break;
        case 4:
            if (state.level > 4)
                if (getCurrentCardItem().parfums.length !== 0)
                    return (<>
                        <div className="current">
                            <div className="rparfums">
                                <span>{getParfums().map(x => x.displayName).join(', ')}</span>
                            </div>
                        </div>

                    </>)
            break;
        case 5:
            if (state.level > 5)
                if (getCurrentCardItem().sucre !== 0)
                    return (<>
                        <div className="current">
                            <div className="rparfums">
                                <div className="sucrespiner">
                                    <CircularProgressbar value={getSucre().value} text={`${getSucre().value}%`} />
                                </div>
                            </div>
                        </div>

                    </>)
            break;
        case 6:
            if (state.level > 6)
                if (getCurrentCardItem().garnitures.length !== 0)
                    return (<>
                        <div className="current">
                            <div className="garnitures">
                                <span>{ConfigMenu.groupby(getCurrentCardItem().garnitures).map(x => x.name + (x.count > 1 ? ` (x${x.count})` : "")).join(', ')}</span>
                            </div>
                        </div>

                    </>)
            break;
        default:
            return (<></>)
            break;
    }


}

export let Payment = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? py.development : py.prodtest



export const SuccessPage = () => {
    return (
        <div className="sweetroot">
            <div className="myposok">
                <div>
                    <img src={logo}></img>
                    <h3>Nous avons bien recu votre commande</h3>
                    <h3>Elle est en cours de préparation...</h3>
                    <h3>Consultez vos mails pour récuperez votre code de commande</h3>
                    <button onClick={() => { window.location = '/' }}><h3>Revenir à l'accueil</h3> </button>
                </div>
            </div>
        </div>)
}

export const ErrorPage = () => {
    return (
        <div className="sweetroot">
            <div className="myposfail">
                <div>
                    <h2>Une erreur est survenu durant le paiement</h2>
                    <button onClick={() => { window.location = '/' }}><h3>Revenir à l'accueil</h3> </button>
                </div>
            </div>
        </div>)
}



export const SweetStepper = (props) => {
    return (<div className="topbanner">
        <div className="logo">
            <a href="https://sweethe.fr/">
                <img src={logo} alt="" />
            </a>
        </div>
        <div className="selection">
            <span className="title">Votre sélection</span>
            <div className="sweetstepper">
                <Stepper state={props.state} StepClickCallBack={(i) => { props.StepClickCallBack(i) }} />
            </div>
        </div>
    </div>)
}



export const UnderStepperLibelle = (props) => {
    return (
        <div className={`menusweet e${LevelToEtape[props.level].number}`}>
            <div className="libelle">
                {LevelToEtape[props.level].Desc}
            </div>
        </div>
    )

}


export const Footer = (props) => {

    const IsFooterRetourEnable = () => {
        if (props.level > 0) // Apres le choix du pdr
            if (props.level <= 8) //Avant le Panier
                return true
        return false;
    };

    const Callback = () => {
        if (props.allowReturnTocard)
            props.ShopCallback()
    }

    const RetourCallback = () => {
        if (IsFooterRetourEnable())
            props.RetourCallback()
    }

    if (IsFooterRetourEnable() == false)
        return (<></>)

    return (<div className="footer">


        <div className="col1" /*onClick={Callback}> desactivated ramene trop d'incohérence*/></div>
        <div className="col2" /*onClick={Callback}> desactivated ramene trop d'incohérence*/>
            <div className={(props.level < 3 && !props.allowReturnTocard) ? "hidden" : ""}>
                <svg viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet"  >
                    <g>
                        <g>
                            <g>
                                <path d="M509.9,107.6c-2.1-2.1-4.3-4.3-8.5-4.3H96L85.3,47.9c0-4.3-6.4-8.5-10.7-8.5h-64C4.3,39.3,0,43.6,0,50
				s4.3,10.7,10.7,10.7h55.5l51.2,260.3c6.4,34.1,38.4,59.7,72.5,59.7h245.3c6.4,0,10.7-4.3,10.7-10.7s-4.3-10.7-10.7-10.7H192
				c-17.1,0-34.1-8.5-42.7-23.5l311.5-42.7c4.3,0,8.5-4.3,8.5-8.5L512,114C512,114,512,109.7,509.9,107.6z M492.4,103.3l-24.6,96.7
				c-10.7,44.5-47.7,77.8-93.1,83.8l-133.8,17.4c-57.6,7.5-111.1-30.9-122.5-87.8L96,103.3"/>
                            </g>
                        </g>
                        <g>
                            <g>
                                <path d="M181.3,384c-29.9,0-53.3,23.5-53.3,53.3c0,29.9,23.5,53.3,53.3,53.3c29.9,0,53.3-23.5,53.3-53.3
				C234.7,407.5,211.2,384,181.3,384z M181.3,469.3c-17.1,0-32-14.9-32-32s14.9-32,32-32s32,14.9,32,32S198.4,469.3,181.3,469.3z"/>
                            </g>
                        </g>
                        <g>
                            <g>
                                <path d="M394.7,384c-29.9,0-53.3,23.5-53.3,53.3c0,29.9,23.5,53.3,53.3,53.3c29.9,0,53.3-23.5,53.3-53.3S424.5,384,394.7,384z
				 M394.7,469.3c-17.1,0-32-14.9-32-32s14.9-32,32-32s32,14.9,32,32S411.7,469.3,394.7,469.3z"/>
                            </g>
                        </g>
                    </g>
                    <text x="300" y="250" textAnchor="middle" className="st0 st1">{props.quantity}</text>
                </svg>
            </div>
        </div>
        <div className="col3" /*onClick={Callback}> desactivated ramene trop d'incohérence*/>
            <div className={(props.level < 3 && !props.allowReturnTocard) ? "hidden" : ""}>Total : {props.totale}€</div></div>
        <div className="col4">
            <svg viewBox="0 0 100 100">
                <path d="M40 15 L40 85" />
                <path d="M50 0 L50 100" />
                <path d="M60 15 L60 85" />
            </svg>
        </div>
        <div className="col5" onClick={RetourCallback}>Retour</div>
        <div className="col6"></div>
    </div>)
}